import { z } from 'zod';

// Messages de validation par défaut en français. Un champ qui porte son propre message
// (ex. `'Requis'`) garde celui-ci ; ceci ne comble que les champs qui n'en ont pas.
z.config(z.locales.fr());
